<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
      <i-page-title title="orgnManage" />
      <v-col cols="12" sm="12" lg="12" class="pa-2 pb-0">
        <v-tabs right active-class="active_tab" v-model="selectedTab">
          <v-tabs-slider></v-tabs-slider>
          <v-tab v-for="item in tabs" :key="item.tabpageId" @click="clickTab">{{ item.title }}</v-tab>
          <!-- /////////////////////////////////////// /* 조직구성도 탭 구성 */ /////////////////////////////////////// -->
          <v-tab-item>
            <i-card-top class="d-md-flex" headercompId="" :useBtnList="buttonOrgnUseList" @btnSave="btnSave()" @btnSearch="btnSearchOrgnDiagram()">
              <!-- headercompId="프로그램 관리" -->
              <template v-slot:body>
                <v-layout column>
                  <v-row no-gutters align="center" class="pa-2 pb-0">
                    <v-col cols="4" sm="4">
                      <v-select
                        :menu-props="{ offsetY: true }"
                        color="primary"
                        class="required mx-1 rounded-0"
                        item-text="OrgnVerCd"
                        item-value="OrgnVerCd"
                        :prepend-inner-icon="$t('$search')"
                        :items="getOrgnVerList"
                        label="조직구성 차수"
                        dense
                        outlined
                        v-model="selectedOrgnVersion"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="8" sm="8" class="pa-0">
                      <v-subheader class="pl-2 text-caption ">
                        <div class="font-weight-bold">생성날짜 :</div>
                        <div class="pl-2">2022.04.21</div>
                        <div class="pl-4 font-weight-bold">확정일자 :</div>
                        <div class="pl-2">미확정</div>
                      </v-subheader>
                    </v-col>
                  </v-row>
                </v-layout>
              </template>
            </i-card-top>

            <i-card-vertical headerTitle="조직구성도">
              <template v-slot:body>
                <!-- 메인 컨텐츠 -->
                <div id="container">
                  <!-- <DxDiagram
                    id="diagram"
                    ref="diagram"
                    custom-shape-template="CustomShapeTemplate"
                    custom-shape-toolbox-template="CustomShapeToolboxTemplate"
                    @request-layout-update="onRequestLayoutUpdate"
                    @custom-command="onCustomCommand"
                    :auto-zoom-mode="'fitWidth'"
                    :simple-view="true"
                  > -->
                  <DxDiagram
                    id="diagram"
                    ref="diagram"
                    custom-shape-template="CustomShapeTemplate"
                    @request-layout-update="onRequestLayoutUpdate"
                    @custom-command="onCustomCommand"
                    :auto-zoom-mode="'fitWidth'"
                    :simple-view="true"
                  >
                    <DxContextMenu :enabled="true" :commands="['bringToFront', 'sendToBack', 'lock', 'unlock']" />
                    <!-- <DxCustomShape
                      :type="'employee'"
                      :category="'employees'"
                      :base-type="'rectangle'"
                      :title="'New Employee'"
                      :default-width="1.5"
                      :default-height="1"
                      :toolbox-width-to-height-ratio="2"
                      :min-width="1.5"
                      :min-height="1"
                      :max-width="3"
                      :max-height="2"
                      :allow-edit-text="false"
                    /> -->
                    <DxCustomShape
                      :ref="'employee' + employee.esgHrNo"
                      v-for="employee in getRiskHumanResources"
                      :category="employee.riskAssRole"
                      :type="'employee' + employee.esgHrNo"
                      :base-type="'rectangle'"
                      :title="'New Employee'"
                      :default-width="1.5"
                      :default-height="1"
                      :toolbox-width-to-height-ratio="2"
                      :default-text="employee.hrDelYn != 'Y' ? `${employee.korNm}(${employee.esgHrNo})` : `${employee.hrDelYn}`"
                      :allow-edit-text="false"
                      :key="employee.esgHrNo"
                      :min-width="1.5"
                      :min-height="1"
                      :max-width="3"
                      :max-height="2"
                    />
                    <template #CustomShapeTemplate="{ data }">
                      <!-- <CustomShapeTemplate :employee="data.dataItem" :edit-employee="editEmployee" :delete-employee="deleteEmployee" /> -->
                      <CustomShapeTemplate :employee="data.dataItem" :riskHr="riskHr" :delete-employee="deleteEmployee" />
                    </template>
                    <!-- <template #CustomShapeToolboxTemplate="{ data }">
                      <CustomShapeToolboxTemplate :employees="getRiskHumanResources" />
                    </template> -->
                    <DxNodes
                      :data-source="getRiskDetailDatasource"
                      :key-expr="'id'"
                      :type-expr="'type'"
                      :custom-data-expr="itemCustomDataExpr"
                      :text-style-expr="textStyleExpr"
                      :parent-key-expr="'headId'"
                    >
                      <DxAutoLayout :type="'tree'" />
                    </DxNodes>
                    <DxEdges :style-expr="styleExpr" />
                    <DxContextToolbox :shape-icons-per-row="1" :width="200" />

                    <DxToolbox :show-search="true" :shape-icons-per-row="1" :width="220" :visible="true" css-class="DxtoolBox">
                      <DxGroup
                        v-for="item in riskOrgnGroupShapeList"
                        :category="item.minorCd"
                        :key="item.minorCd"
                        :title="item.minorNm"
                        :expanded="true"
                        :display-mode="'texts'"
                      />
                    </DxToolbox>
                    <DxPropertiesPanel>
                      <DxTab>
                        <DxGroup :title="'Page Properties'" :commands="['pageSize', 'pageOrientation', 'pageColor']" />
                      </DxTab>
                    </DxPropertiesPanel>
                  </DxDiagram>
                </div>
              </template>
            </i-card-vertical>
          </v-tab-item>
          <!-- /////////////////////////////////////// /* 조직구성 차수 이력 탭 구성 */ /////////////////////////////////////// -->
          <v-tab-item>
            <v-col cols="12" sm="12" lg="12" class="pa-0 pb-0">
              <i-card-top
                class="d-flex"
                headercompId=""
                :useBtnList="buttonOrgnVersionList"
                @btnAdd="btnOrgnVerHistAdd()"
                @btnSearch="btnOrgnVerHistSearch()"
                @btnSave="btnOrgnVerSave()"
                @btnDelete="btnOrgnVerDelete()"
              >
                <template v-slot:body>
                  <v-layout overflow-auto>
                    <v-row no-gutters align="center pa-2"> </v-row>
                  </v-layout>
                </template>
              </i-card-top>
            </v-col>
            <v-col cols="12" sm="12" lg="12" class="pa-0 pt-0">
              <i-card-vertical headerTitle="조직차수이력">
                <template v-slot:body>
                  <v-layout column overflow-auto>
                    <v-col cols="12" md="12" class="row pa-0">
                      <DxDataGrid
                        id="orgnDataGrid"
                        class="layout-col-height00"
                        :ref="dxDataGridRef"
                        :data-source="orgnVersionhistDatasource"
                        :remote-operations="false"
                        :hover-state-enabled="true"
                        :allow-column-reordering="true"
                        :allow-column-resizing="true"
                        :row-alternation-enabled="true"
                        :column-auto-width="true"
                        :show-borders="true"
                        :show-row-lines="true"
                        :selection="{ mode: 'single' }"
                        key-expr="orgnOrder"
                        :focused-row-enabled="true"
                        :focused-row-index="0"
                        @focused-row-changed="onFocusedRowChanged"
                        @editing-start="onEditingStart"
                        @row-updating="onRowUpdating"
                        @editor-preparing="onEditorPreparing"
                        @content-ready="onContentReady"
                      >
                        <DxPaging />
                        <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                        <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />
                        <DxPager
                          :visible="pager.visible"
                          :allowed-page-sizes="pager.pageSizes"
                          :display-mode="pager.savigationMode"
                          :show-navigation-buttons="pager.showNavButtons"
                        />
                        <DxColumn
                          data-field="orgnOrder"
                          data-type="string"
                          width="100px"
                          alignment="center"
                          caption="차수"
                          :allow-editing="false"
                          css-class="devest-grid-header-require"
                        />
                        <DxColumn
                          data-field="view"
                          data-type="string"
                          width="40px"
                          alignment="center"
                          caption="보기"
                          :allow-editing="false"
                          :cell-template="'moveButton'"
                          css-class="devest-grid-header-require"
                        />

                        <template #moveButton="{ data: cellInfo }">
                          <v-btn icon color="gray" class="move" x-small @click="btnMoveOrgnVerlick(cellInfo)">
                            <!-- <v-icon>mdi-comment-account-outline</v-icon> -->
                            <svg-icon icon-class="tree"></svg-icon>
                          </v-btn>
                          <!-- <DxButton text="move" :visible="true" @btnClick="btnMoveOrgnVerlick(cellInfo)" /> -->
                        </template>

                        <DxColumn :checked="true" data-field="orgnOrderNm" data-type="string" width="180px" alignment="left" caption="차수명" />

                        <DxColumn
                          data-field="createdAt"
                          data-type="date"
                          format="yyyy.MM.dd HH:mm:ss"
                          ,
                          width="130px"
                          alignment="center"
                          caption="생성일자"
                          :allow-editing="false"
                        />
                        <DxColumn
                          data-field="confirmYn"
                          data-type="boolean"
                          width="90"
                          alignment="center"
                          caption="확정여부"
                          edit-cell-template="checkBoxEditor"
                        />
                        <DxColumn
                          data-field="confirmDt"
                          data-type="date"
                          format="yyyy.MM.dd HH:mm:ss"
                          width="130px"
                          alignment="center"
                          caption="확정일자"
                          :allow-editing="false"
                        />
                        <DxColumn
                          data-field="cancelYn"
                          data-type="boolean"
                          width="90"
                          alignment="center"
                          caption="취소여부"
                          edit-cell-template="checkBoxEditor"
                        />
                        <DxColumn
                          data-field="cancelDt"
                          data-type="date"
                          format="yyyy.MM.dd HH:mm:ss"
                          width="130px"
                          alignment="center"
                          caption="취소일자"
                          :allow-editing="false"
                        />

                        <DxColumn data-field="remark" data-type="string" alignment="left" caption="비고" />

                        <template #checkBoxEditor="{ data: cellInfo }">
                          <!-- <DxCheckBox
                            v-if="cellInfo.column.dataField == 'confirmYn'"
                            :value="cellInfo.value == 'Y' ? true : false"
                            :onValueChanged="value => onCheckValueChanged(value, cellInfo)"
                          />
                          <DxCheckBox
                            v-else-if="cellInfo.column.dataField == 'cancelYn'"
                            :value="cellInfo.value == 'Y' ? true : false"
                            :onValueChanged="value => onCheckValueChanged(value, cellInfo)"
                          /> -->
                          <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onCheckValueChanged(value, cellInfo)" />
                        </template>
                        <!-- <DxScrolling mode="virtual" show-scrollbar="always" /> -->
                      </DxDataGrid>
                    </v-col>
                  </v-layout>
                </template>
              </i-card-vertical>
            </v-col>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import iCardVertical from '@/components/common/iCardVertical.vue'
import iPageTitle from '@/components/common/iPageTitle.vue'
import OrgChart from '@/components/organization/OrganizationChartContainer.vue'

import { DxColumn, DxDataGrid, DxEditing, DxFilterRow, DxPager, DxPaging, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
//import { DxDataGrid, DxColumn, DxScrolling, DxPager } from 'devextreme-vue/data-grid'
//
import CustomShapeTemplate from '@/components/organization/CustomShapeTemplate.vue'
import CustomShapeToolboxTemplate from '@/components/organization/CustomShapeToolboxTemplate.vue'
import { getUserCd } from '@/utils/token'
import DxButton from 'devextreme-vue/button'
import DxCheckBox from 'devextreme-vue/check-box'
import {
  DxAutoLayout,
  DxContextMenu,
  DxContextToolbox,
  DxCustomShape,
  DxDiagram,
  DxEdges,
  DxGroup,
  DxNodes,
  DxPropertiesPanel,
  DxTab,
  DxToolbox
} from 'devextreme-vue/diagram'
import { DxPopup } from 'devextreme-vue/popup'
import DxTextBox from 'devextreme-vue/text-box'
import ArrayStore from 'devextreme/data/array_store'

//

import {
  deleteRiskOrgnManageMaster,
  getHumanResourceByRiskAsse,
  //위험성평가 조직 디테일
  getRiskOrgnManageDetail,
  //위험성평가 조직 마스터
  getRiskOrgnManageMaster,
  saveRiskOrgnManageDetail,
  saveRiskOrgnManageMaster
} from '@/api/baseManage/riskOrgnManage'

import iCardTop from '@/components/common/iCardTop.vue'
import Baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가

//const that = this

export default {
  extends: Baseview, //20220414 LYJ base page 추가
  name: 'orgnManage',
  components: {
    'i-page-title': iPageTitle,
    iCardVertical,
    OrgChart,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPager,
    //
    DxDiagram,
    DxNodes,
    DxEdges,
    DxAutoLayout,
    DxCustomShape,
    DxContextToolbox,
    DxPropertiesPanel,
    DxGroup,
    DxTab,
    DxToolbox,
    CustomShapeTemplate,
    CustomShapeToolboxTemplate,
    DxPopup,
    DxTextBox,
    DxButton,
    DxContextMenu,
    DxCheckBox,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxEditing
  },
  created() {},
  data() {
    return {
      currentEmployee: {},
      popupVisible: false,
      //
      dxDataGridRef: 'orgnDataGrid',
      tabs: [
        { tabpageId: 'orgnDiagram', title: '위험성평가조직' },
        { tabpageId: 'orgnVerHist', title: '차수이력' }
      ],
      selectedTab: '1',
      selectOrgnVerList: [], //[{ OrgnVerCd: '2022-04-01' }, { OrgnVerCd: '2022-04-02' }, { OrgnVerCd: '2022-04-03' }],
      selectedOrgnVersion: '',
      buttonOrgnUseList: [
        'btnSearch', //조회
        'btnSave' //저장
      ],
      buttonOrgnVersionList: ['btnSearch', 'btnAdd', 'btnSave', 'btnDelete', 'btnEditCancel'],
      orgnVersionhistDatasource: [],
      ds: [],
      dataSource: new ArrayStore({
        key: 'id',
        data: []
      }),
      riskHr: [
        // { esgHrNo: '1', korNm: '김종길', jbrp: 'B11', jbrpNm: '부장', riskAssRole: 'A10', riskAssRoleNm: '안전보건관리책임자' },
        // { esgHrNo: '2', korNm: '임윤주', jbrp: 'B12', jbrpNm: '차장', riskAssRole: 'B10', riskAssRoleNm: '위험성평가 담당자' },
        // { esgHrNo: '7', korNm: '백이서', jbrp: 'B16', jbrpNm: '사원', riskAssRole: 'F10', riskAssRoleNm: '관리감독자' },
        // { esgHrNo: '8', korNm: '원지윤', jbrp: 'B16', jbrpNm: '사원', riskAssRole: 'G10', riskAssRoleNm: '근로자' },
        // { esgHrNo: '3', korNm: '유현창', jbrp: 'B16', jbrpNm: '사원', riskAssRole: 'C10', riskAssRoleNm: '안전관리자' },
        // { esgHrNo: '4', korNm: '손상규', jbrp: 'B16', jbrpNm: '사원', riskAssRole: 'D10', riskAssRoleNm: '보건관리자' },
        // { esgHrNo: '5', korNm: '안성훈', jbrp: 'B16', jbrpNm: '사원', riskAssRole: 'E10', riskAssRoleNm: '안전보건관리자' }
      ],
      riskOrgnGroupShapeList: [{ minorCd: '', minorNm: '' }],
      saveOrgnResultData: [],
      generatedID: 100,
      cusomeHrResourceVisible: true
    }
  },
  computed: {
    getCheckStatus(dataField, data) {
      ////console.log(dataField)
      if ((dataField == 'confirmYn' && data.cancelYn == 'Y') || (dataField == 'cancelYn' && data.confirmYn == 'Y')) return false
      else return true
    },
    getOrgnVerList() {
      return this.selectOrgnVerList
    },

    orgnOrderDataGrid: function() {
      return this.$refs[this.dxDataGridRef].instance
    },
    getRiskHumanResources() {
      return this.riskHr //.filter(x => x.hrDelYn != 'Y')
    },
    getRiskDetailDatasource() {
      this.dataSource = new ArrayStore({
        key: 'id',
        data: this.ds, //service.getEmployees(),
        onInserting(values) {
          ////console.log('onInserting')
          //////console.log(values)
          //////console.log(this.riskHr)
          // this.currentEmployee.esgHrNo = values.esgHrNo = 12 //values.esgHrNo /*|| (this.generatedID += 1)*/
          // this.currentEmployee.korNm = values.text //values.korNm /*|| "Employee's Name"*/
          // this.currentEmployee.riskAssRoleNm = values.riskAssRoleNm = '역할추가'
          // this.currentEmployee.jbrpNm = values.jbrpNm = '직급추가'
          // values.compId = values.compId /*|| "Employee's compId"*/
          // values.headId = values.headId
          ////console.log(JSON.stringify(values))
          // values.no = values.no
          values.esgHrNo = values.type.replace('employee', '')
          values.id = values.id //values.esgHrNo + '' + (this.generatedID += 1)
          // values.compId = 'IGNS'
          // values.korNm = '이름'
          // values.riskAssRoleNm = '역할'
          // values.jbrpNm = '직급'
          // values.type = values.type
          // values.orgnOrder = this.selectedOrgnVersion
          // this.currentEmployee = { esgHrNo: 12, korNm: values.text, riskAssRoleNm: '역할추가', jbrpNm: '직급추가', type: values.type }
          // ////console.log(this.data)
          // this.ds.push(this.currentEmployee)
        }
      })

      return this.dataSource
    },
    getRiskOrgnList() {
      return this.riskOrgnGroupShapeList
    }
  },
  beforeMount() {
    //커스텀 Shape를 위한 역할 그룹 조회
    Promise.all([getCommonCode({ compId: this.comp.id, majorCd: 'C0009' })])
      .then(response => {
        let failedResponse = response.find(element => !element.success)
        if (failedResponse == null) {
          this.riskOrgnGroupShapeList = response[0].list.slice()
          //////console.log('riskOrgnGroupShapeList : ' + JSON.stringify(this.riskOrgnGroupShapeList))
        } else {
          ////console.log(failedResponse.msg)
        }
      })
      .catch(error => {})
    //컴포넌트를 위한 조직 버전 리스트 조회
    this.searchOrgnVerList()
    //커스텀 Shape를 위한 인원정보 조회
    this.searchHrInfo()
    //조직구성도 다이아그램 정보 조회
    this.getOrgnDiagramData()
    // //차수이력 조회
    // this.btnOrgnVerHistSearch()
  },
  mounted() {},
  updated() {
    // //console.log('updated()')
  },
  beforeUpdate() {
    //    //console.log('beforeupdated()')
  },
  activated() {
    //   //console.log('activated')
  },
  methods: {
    //조직구성도 트리 저장하기
    btnSave() {
      this.saveOrganization()
    },
    saveOrganization() {
      //유효성 체크
      //확정여부 조회

      //
      this.saveOrgnResultData = []
      this.dataSource._array.forEach(x => {
        ////console.log(this.selectedOrgnVersion)
        x.orgnOrder = this.selectedOrgnVersion
        if (x.compId == undefined) x.compId = this.comp.id
        //if (x.headId == undefined) x.headId = 'root'

        this.saveOrgnResultData
          .push({
            id: x.id,
            compId: x.compId,
            orgnOrder: x.orgnOrder,
            esgHrNo: x.esgHrNo,
            headId: x.headId
          })
          .catch(x => {
            //console.log(x)
          })
        ////console.log(x.esgHrNo + '/' + x.id + '/' + x.orgnOrder + '/' + x.compId)
      })
      ////console.log(this.saveOrgnResultData)
      //DB에 저장
      saveRiskOrgnManageDetail(this.saveOrgnResultData, true)
        .then(res => {
          if (res.success) {
            this.getOrgnDiagramData()
          } else {
            this.$vToastify.error({ body: res.msg })
          }
        })
        .catch(error => {})
        .finally(() => {})

      //this.outputOrganizationText = JSON.stringify(this.ds)
    },

    btnSearchOrgnDiagram() {
      this.getOrgnDiagramData()
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //조직 구성도 조회
    getOrgnDiagramData() {
      //getRiskOrgnManageDetail

      if (this.comp == undefined) this.$vToastify.error({ body: this.$t('msgNoReqConditionsComp') })

      // if (this.selectedOrgnVersion == '') {
      //   this.$vToastify.warning({ body: this.$t('조직구성 차수를 선택하세요') })
      //   return
      // }

      this.openLoading('searching')
      let params = {
        compId: this.comp == null || this.comp == undefined ? '' : this.comp.id,
        orgnOrder: this.selectedOrgnVersion
      }

      ////console.log(JSON.stringify(params))
      getRiskOrgnManageDetail(params, true)
        .then(res => {
          if (res.success) {
            //dataSource.data = res.list
            //this.employees = res.list
            this.ds = res.list
            this.searchHrInfo() //인원정보 재조회하기
            //this.dataSource.data = res.list
            // res.list.forEach(element => {
            //   this.dataSource.insert(element)
            // })

            //////console.log(this.ds)
            //////console.log('getRiskOrgnManageDetail success!')
          } else {
            // -2000 조회결과가 없음
            if (res.code == -2000) {
              this.ds = []
            }
            // this.$vToastify.warning({ body: res.msg })
          }
        })
        .catch(error => {})
        .finally(() => {
          this.endLoading()
        })
    },

    //조직 구성도 커스텀 세이프 컴포넌트 인원정보 조회
    searchHrInfo() {
      //////console.log('searchHrInfo()')
      let params = {
        compId: this.comp == null || this.comp == undefined ? '' : this.comp.id
      }
      //윤주
      getHumanResourceByRiskAsse(params, false)
        .then(res => {
          if (res.success) {
            //console.log('getHumanResourceByRiskAssen!!!!@@@@@@@@@')
            //console.log(res.list)
            this.riskHr = res.list

            //모든 트리노드 검색하여 items를 세팅
            //this.ds.items = this.riskHr //rootNoe 세팅
            //let rootNode = this.setRiskHrItems(this.ds, res.list)
            ////////console.log(this.ds)
            //////console.log('searchHrInfo() 성공')
            //////console.log(rootNode)
            //this.ds = rootNode
            let target = document.getElementsByClassName('dx-diagram-toolbox-popup')
            target[1].style.left = '700px'
            //console.log(target[1])
            let HrResourceItemOfToolbar = document.querySelectorAll(
              '#diagram .dx-accordion-item-opened > .dx-accordion-item-body > .dxdi-toolbox >.toolbox-text-item'
            )
            // var style = document.createElement('style')
            // //style.type = 'text/css'
            // style.innerHTML = '.cssClass { color: #F00; }'
            // document.getElementsByTagName('head')[0].appendChild(style)

            // document.getElementById('someElementId').className = 'cssClass'
            //console.log(HrResourceItemOfToolbar)
            HrResourceItemOfToolbar.forEach(x => {
              x.style.display = 'none'
              //console.log(x.textContent)
              if (x.textContent == 'Y') {
                //console.log('1' + x.textContent)
                x.style.display = 'none'
                x.style.cssText = 'color:red;'
                x.textContent = ''
                // x.appendChild(style)
                // x.className = 'cssClass'
                //console.log('2' + x.style.display)
              }
            })
          }
        })
        .catch(error => {})
        .finally(() => {
          return true
        })
    },
    //모든 트리노드 검색하여 items를 세팅
    setRiskHrItems(rootNode, riskHr) {
      //////console.log('setRiskHrItems : ' + rootNode.esgHrNo)
      rootNode.children.some(el => {
        el.items = riskHr
        //////console.log(el)
        if (el.children && el.children.length > 0) this.setRiskHrItems(el, riskHr)
        else return
      })

      return rootNode
    },
    //------------------------------------------
    //조직 차수 리스트 조회(콤보박스)
    searchOrgnVerList() {
      let params = {
        compId: this.comp == null || this.comp == undefined ? '' : this.comp.id
      }
      this.selectOrgnVerList = []
      getRiskOrgnManageMaster(params, false)
        .then(res => {
          if (res.success) {
            res.list.forEach(element => {
              this.selectOrgnVerList.push({ OrgnVerCd: element.orgnOrder })
            })
            if (this.selectOrgnVerList.length > 0) this.selectedOrgnVersion = this.selectOrgnVerList[this.selectOrgnVerList.length - 1].OrgnVerCd
          }
        })
        .catch(error => {})
        .finally(() => {})
    },
    //------------------------------------------
    //조직 차수 이력 조회
    btnOrgnVerHistSearch() {
      if (this.comp == undefined) this.$vToastify.error({ body: this.$t('msgNoReqConditionsComp') })

      this.openLoading('searching')
      let params = {
        compId: this.comp == null || this.comp == undefined ? '' : this.comp.id
      }

      getRiskOrgnManageMaster(params, true)
        .then(res => {
          if (res.success) {
            ////console.log(res.list)

            this.gridInit()
            this.orgnVersionhistDatasource = res.list

            this.orgnVersionhistDatasource.forEach(x => (x.cancelYn = x.cancelDt != null ? 'Y' : 'N'))

            //focus the first row
            this.FocusFirstRow(this.orgnOrderDataGrid)
          }
        })
        .catch(error => {})
        .finally(() => {
          this.endLoading()
        })
    },
    //조직 차수 추가
    btnOrgnVerHistAdd() {
      ////console.log('btnOrgnVerHistAdd')
      let newRow = {
        orgnOrder: 'insert-' + (this.orgnVersionhistDatasource.length + 1),
        compId: this.comp.id,
        cancelYn: 'N',
        confirmYn: 'N',
        delYn: 'N'
      }

      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })
      this.orgnOrderDataGrid.newRow(newRow)
    },

    //조직 차수 저장
    btnOrgnVerSave() {
      ////console.log('saveRiskOrgnManageMaster')
      // this.orgnOrderDataGrid.saveEditData()
      var selectedRows = this.orgnOrderDataGrid.getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.$vToastify.warning({ body: this.$t('selection_Data') })
        return
      }
      var pattern = /\s/g
      //입력값 Check
      var index = selectedRows.findIndex(element => element.orgnOrder == null || element.orgnOrder.match(pattern) != null)
      if (index >= 0) {
        this.vToastify(`${this.$t('msgReqValidate')}`, 'warn')
        return
      }

      this.$vToastify
        .prompt({
          body: this.$t('doSaveData'),
          answers: { Yes: true, No: false }
        })
        .then(value => {
          if (!value) return
          else {
            this.openLoading('saving')
            //console.log(selectedRows)
            this.orgnOrderDataGrid.saveEditData()
            saveRiskOrgnManageMaster(selectedRows, true)
              .then(res => {
                if (res.success) {
                  this.gridInit()
                  //데이타 재조회
                  this.btnOrgnVerHistSearch()
                }
              })
              .catch(error => {})
              .finally(() => {
                this.endLoading()
              })
          }
        })
    },

    //조직 차수 삭제
    btnOrgnVerDelete() {
      var selectedRows = this.orgnOrderDataGrid.getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.$vToastify.warning({ body: this.$t('selection_Data') })
        return
      }

      this.$vToastify
        .prompt({
          body: this.$t('doDeleteData'),
          answers: { Yes: true, No: false }
        })
        .then(value => {
          if (!value) return
          else {
            this.openLoading('deleting')

            selectedRows.forEach(key => {
              key.updatedBy = getUserCd()
            })

            //삭제 처리
            deleteRiskOrgnManageMaster(selectedRows, true)
              .then(res => {
                if (res.success) {
                  this.deleteCallBack(selectedRows)
                }
              })
              .catch(error => {})
              .finally(() => {
                this.endLoading()
              })
          }
        })
    },

    ///////////////////////////////////////
    /*        DataGrid Event Event       */
    ///////////////////////////////////////
    //행 cell에서 데이터 수정후 저장을 누르면 선택된 데이터가 없다는 메세지가 발생
    //위 문제를 해결하기 위해서 아래 소스코드 구현
    onRowUpdating(e) {
      this.orgnOrderDataGrid.selectRows(e.key, true)
      //this.orgnOrderDataGrid.saveEditData()
    },
    onEditingStart(e) {
      if (
        e.column.dataField == 'cancelYn' ||
        e.column.dataField == 'confirmYn' ||
        e.column.dataField == 'orgnOrderNm' ||
        e.column.dataField == 'remark'
      ) {
        ////console.log('onEditingStart')
        e.cancel = false
      } else e.cancel = true
    },
    onCheckValueChanged(value, cellInfo) {
      //  //console.log('cellInfo')
      //  //console.log(cellInfo)
      //  //console.log('value')
      //  //console.log(value)
      //
      //확정은 한개만 할 수 있고 취소는 확정이 완료된 건에 대해서만 취소 시킬 수 있다.
      if (cellInfo.column.dataField == 'cancelYn' && cellInfo.value === 'N') {
        if (cellInfo.row.cells[6].data.confirmDt == null) {
          this.$vToastify.warning({ body: this.$t('확정된 차수만 취소할 수 있습니다.') })
          return
        }
      }

      if (cellInfo.column.dataField == 'confirmYn' && cellInfo.value === 'N') {
        let visibleRows = cellInfo.component.getVisibleRows()
        visibleRows.forEach(row => {
          if (row.data.confirmYn == 'Y') {
            row.data.confirmYn = 'N'
            this.orgnOrderDataGrid.selectRows(row.key, true)
          }
          //row.cells[6].value = 'N'
          if (row.data.cancelYn == 'Y') {
            row.data.cancelYn = 'N'
            this.orgnOrderDataGrid.selectRows(row.key, true)
          }
        })

        cellInfo.row.data.cancelYn = cellInfo.value === 'Y' ? 'Y' : 'N'
      }
      if (cellInfo.column.dataField == 'cancelYn' && cellInfo.value === 'N') {
        let visibleRows = cellInfo.component.getVisibleRows()
        visibleRows.forEach(row => {
          if (row.data.cancelYn == 'Y') {
            row.data.cancelYn = 'N'
            this.orgnOrderDataGrid.selectRows(row.key, true)
          }
          if (row.data.confirmYn == 'Y') {
            row.data.confirmYn = 'N'
            this.orgnOrderDataGrid.selectRows(row.key, true)
          }
        })
        cellInfo.row.data.confirmYn = cellInfo.value === 'Y' ? 'Y' : 'N'
      }

      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      this.orgnOrderDataGrid.selectRows(cellInfo.key, true)
      //this.orgnOrderDataGrid.saveEditData()
      cellInfo.component.updateDimensions()
    },

    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged

        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) {
            valueChanged(args.value, e)
          }
        }
      }
    },

    onCellValueChanged(value, cellInfo) {
      ////console.log('onCellValueChanged')
      cellInfo.setValue(value)
      this.orgnOrderDataGrid.selectRows(cellInfo.row.key, true)
      //this.orgnOrderDataGrid.saveEditData()
    },

    onContentReady(e) {
      //////console.log(e)
    },

    gridInit() {
      this.orgnOrderDataGrid.cancelEditData()
      this.orgnOrderDataGrid.clearSelection()
      // this.orgnOrderDataGrid.cancelEditData()
      // this.orgnOrderDataGrid.deselectAll()
    },

    deleteCallBack(selectedRows) {
      var index = null
      selectedRows.forEach(key => {
        index = this.orgnVersionhistDatasource.findIndex(obj => obj.orgnOrder == key.orgnOrder)
        this.orgnVersionhistDatasource.splice(index, 1)
      })
    },
    FocusFirstRow(dataGrid) {
      ////console.log('FocusFirstRow')
      //const rowKey = dataGrid.getKeyByRowIndex(0)
      dataGrid.option('focusedRowIndex', 0)
    },

    ///////////////////////////////////////
    /*        ETC Event Event       */
    ///////////////////////////////////////
    btnMoveOrgnVerlick(cellInfo) {
      ////console.log(cellInfo)
      ////console.log('btnMoveOrgnVerlick 선택된 차수 : ' + cellInfo.row.key)
      this.selectedOrgnVersion = cellInfo.row.key
      this.selectedTab = '1'
      this.getOrgnDiagramData()
    },
    clickTab() {
      ////console.log(this.selectedTab)
    },
    clearFilter() {
      this.$refs[this.dxDataGridRef].instance.clearFilter()
    },

    onFocusedRowChanged() {},
    openLoading(msg) {
      this.$vToastify.loader({
        title: this.$t('working'),
        body: this.$t(msg)
      })
    },
    endLoading() {
      this.$vToastify.stopLoader()
    },
    //
    // itemTypeExpr(obj, value) {
    //   ////console.log('itemTypeExpr ' + obj.esgHrNo)
    //   return 'employee' + obj.esgHrNo
    // },
    itemCustomDataExpr(obj, value) {
      if (value === undefined) {
        return {
          korNm: obj.korNm,
          orgnOrder: obj.orgnOrder,
          compId: obj.compId,
          riskAssRoleNm: obj.riskAssRoleNm
        }
      }
      // obj.korNm = value.korNm
      obj.orgnOrder = value.orgnOrder
      obj.compId = value.compId
      obj.esgHrNo = value.esgHrNo
      obj.headId = value.headId
      obj.id = value.id

      return null
    },
    textStyleExpr() {
      return 'visibility:hidden'
    },
    styleExpr() {
      return 'stroke: red'
    },
    onRequestLayoutUpdate(e) {
      for (let i = 0; i < e.changes.length; i += 1) {
        if (e.changes[i].type === 'remove') {
          e.allowed = true
        } else if (e.changes[i].data.headId !== undefined && e.changes[i].data.headId !== null) {
          e.allowed = true
        }
      }
    },
    // editEmployee(employee) {
    //   this.currentEmployee = {
    //     // korNm: '',
    //     orgnOrder: '',
    //     compId: '',
    //     // City: '',
    //     // State: '',
    //     // Email: '',
    //     // Skype: '',
    //     // Mobile_Phone: '',
    //     ...employee
    //   }
    //   this.popupVisible = true
    // },
    deleteEmployee(employee) {
      this.dataSource.push([{ type: 'remove', key: employee.id }])
    },
    updateEmployee() {
      ////console.log('updateEmployee')
      ////console.log(this.currentEmployee)
      this.dataSource.push([
        {
          type: 'update',
          key: this.currentEmployee.esgHrNo,
          data: {
            korNm: this.currentEmployee.korNm,
            riskAssRoleNm: this.currentEmployee.riskAssRoleNm,
            jbrpNm: this.currentEmployee.jbrpNm,
            //compId: this.currentEmployee.compId,
            //orgnOrder: this.currentEmployee.selectedOrgnVersion,
            esgHrNo: this.currentEmployee.esgHrNo
            //headId: this.currentEmployee.headId
          }
        }
      ])
      this.currentEmployee = {}
      //this.popupVisible = false
    },
    cancelEditEmployee() {
      this.currentEmployee = {}
      this.popupVisible = false
    },
    //
    onCustomCommand(e) {
      if (e.name === 'clear') {
        const result = dialog.confirm('Are you sure you want to clear the diagram? This action cannot be undone.', 'Warning')
        result.then(dialogResult => {
          if (dialogResult) {
            e.component.import('')
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .active_tab {
  border-radius: 5px;
  color: black;
  font-weight: bold !important;
  background-color: #e0e7e9;
  height: 30px;
}

::v-deep .v-tabs-slider-wrapper {
  display: block !important;
  top: 37px;
}

::v-deep .v-slide-group__content {
  align-items: center !important;
}

//
#diagram {
  height: 725px;
}

.dx-popup-content {
  padding: 0;
}

.dx-popup-content .dx-fieldset.buttons {
  display: flex;
  justify-content: flex-end;
}

.dx-popup-content .dx-fieldset.buttons > * {
  margin-left: 8px;
}

::v-deep .menuable__content__active {
  z-index: 2000 !important ;
}

// ::v-deep .dx-accordion-item-opened > .dx-accordion-item-body {
//   display: none !important;
// }

::v-deep #diagram > .dx-overlay-wrapper > .dx-overlay-content {
  left: 700px;
}

.displayNone {
  .dx-accordion-item-opened > .dx-accordion-item-body {
    display: none !important;
  }
}
</style>
